import { store } from 'app/shared/store/store';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { ProductsResponse } from 'app/shared/models/product-response.model';
import { ResponseError } from 'app/shared/models/response-error.error';
import { getHeaders } from 'app/shared/utilities/helper-functions';

class MobileProductSearchApiService {
  public getProducts = async (request: ProductSearchRequestModel): Promise<ProductsResponse> => {
    const configData = store.get('configData');
    const init = {
      method: 'POST',
      body: JSON.stringify({
        ...request
      }),
      headers: getHeaders()
    };

    return await fetch(`${configData.bffApiUrl}/products/mobile/search`, init)
      .then((response) => {
        if (!response.ok) {
          throw new ResponseError(`Unable to retrieve mobile products`);
        }

        return response.json();
      })
      .catch((error) => {
        throw new ResponseError(error);
      });
  };

  public getMobileProduct = async (sku: string): Promise<ProductsResponse> => {
    const configData = store.get('configData');
    if (configData) {
      const httpHeaders = getHeaders();

      const requestUrl = `${configData.bffApiUrl}/products/mobile/sku/${sku}`;

      try {
        const response = await fetch(requestUrl, {
          method: 'GET',
          headers: httpHeaders
        });

        return await response.json();
      } catch (e) {
        const error = { code: 'NetworkError', message: e.message };
        throw error;
      }
    }
  };
}

export const mobileProductSearchApiService = new MobileProductSearchApiService();
